import { getCategoryImageUrl } from '../../../helpers/CategoryMedia'
import React, { useState, useEffect, useContext } from 'react'
import {
    Row,
    Col,
    Input,
    Card,
    CardBody,
    CardTitle,
    CardFooter
} from 'reactstrap'

import { Link } from 'react-router-dom'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { GeneralContext } from '../../../context/'
import ApiService from '../../../data/services/ApiService'
import Avatar from '../../../assets/images/avatar-product-placeholder.png'
import { withRouter } from 'react-router-dom'

const Table = () => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState([])

    useEffect(() => {
        (async () => {
            await fetchData()
        })()

        async function fetchData() {
            setLoading(true)
            const response = await ApiService.getCategories()

            setData(response.data.data)
            setFilteredData(response.data.data)
            setLoading(false)
        }
    }, []) // eslint-disable-line

    const _filterData = async (e) => {
        const keystroke = e.target.value.toLowerCase()
        const filteredData = data.filter((item) => {
            const name = item.name || ''
            const description = item.description || ''

            return name.toLowerCase().includes(keystroke) ||
                description.toLowerCase().includes(keystroke)
        })

        setFilteredData(filteredData)
    }

    const _deleteItem = async (id) => {
        const result = await ApiService.deleteCategory(id)
        if (!result.data.success) {
            toastr.error('No pude eliminar la categoría', 'Error')
        }

        let filtered = await data.filter((v) => { return v.id !== id })

        setData(filtered)
        setFilteredData(filtered)

        toastr.success('Eliminé una categoría', '¡Éxito!')
    }

    return(
        <React.Fragment>
            <Row className="mb-2">
                <Col sm="4">
                    <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative">
                            <Input type="text" className="form-control"
                                placeholder={`Buscar`}
                                onKeyUp={(e) => _filterData(e)}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                        </div>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col style={{ textAlign: 'center' }} md={4} sm={12} xs={12}>
                    <Link to="/categories/add">
                        <img style={{ width: '60%' }} src="/assets/images/add-item.svg" alt={``} />
                    </Link>
                </Col>
                {filteredData && filteredData.map((item, key) => (
                    <Col {...key} md={4} sm={12} xs={12}>
                        <Card>
                            <Row>
                                <Col sm={3}>
                                    {item.image && (
                                        <img width="64" title={item.name} alt={item.name}
                                        src={getCategoryImageUrl(item)} />
                                    )}

                                    {!item.image && (
                                        <img width="64" title={item.name} alt={item.name}
                                        src={Avatar} />
                                    )}
                                </Col>

                                <Col sm={9}>
                                    <CardTitle>
                                        {item.name}{' '}
                                        {item.type === 'ARTIST' && (
                                            <span className="badge badge-info">Artista</span>
                                        )}
                                    </CardTitle>

                                    <CardBody>{item.description}</CardBody>
                                </Col>
                            </Row>

                            <CardFooter className="bg-transparent border-top">
                                <div className="d-flex font-size-20">
                                    <div className="flex-fill">
                                            <Link id={'edit'} to={`/categories/edit/${item.id}`}>
                                                <i className="mdi mdi-pencil"></i> Editar
                                            </Link>
                                        </div>

                                        <div className="flex-fill">
                                            <Link id={'delete'} to={`#`} onClick={(e) => {
                                                e.preventDefault()
                                                _deleteItem(item.id)
                                            }}>
                                                <i className="mdi mdi-trash-can font-size-16 mr-2"></i> Eliminar
                                            </Link>
                                        </div>
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>
                ))}
            </Row>
        </React.Fragment>
    )
}

export default withRouter(Table)
